module.exports = __webpack_public_path__ + "static/media/loanxxxx-logo.fa4c1f94.svg";